"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var english_1 = require("./english");
var nepali_1 = require("./nepali");
var WordValues;
(function (WordValues) {
    WordValues[WordValues["hundred"] = 100] = "hundred";
    WordValues[WordValues["thousand"] = 1000] = "thousand";
    WordValues[WordValues["million"] = 1000000] = "million";
    WordValues[WordValues["billion"] = 1000000000] = "billion";
    WordValues[WordValues["trillion"] = 1000000000000] = "trillion";
    WordValues[WordValues["lakh"] = 100000] = "lakh";
    WordValues[WordValues["crore"] = 10000000] = "crore";
    WordValues[WordValues["arab"] = 1000000000] = "arab";
    WordValues[WordValues["kharab"] = 100000000000] = "kharab";
})(WordValues = exports.WordValues || (exports.WordValues = {}));
exports.WORD_MAPPING = {
    international: {
        en: {
            tenths: english_1.TENTH_MAPPING_EN,
            subHundreds: english_1.SUB_TWENTIES_MAPPING_EN,
            maxValue: 1000 * WordValues.trillion - 1,
            negativeWord: 'minus',
            decimalWord: 'point'
        }
    },
    hinduArabic: {
        en: {
            tenths: english_1.HINDU_ARABIC_TENTH_MAPPING_EN,
            subHundreds: english_1.SUB_TWENTIES_MAPPING_EN,
            maxValue: 100 * WordValues.kharab - 1,
            negativeWord: 'minus',
            decimalWord: 'point'
        },
        np: {
            tenths: nepali_1.TENTH_MAPPING_NP,
            subHundreds: nepali_1.SUB_HUNDRED_NP,
            maxValue: 100 * WordValues.kharab - 1,
            negativeWord: 'माइनस',
            decimalWord: 'दशमलब'
        }
    }
};
//# sourceMappingURL=index.js.map